import {TeachBlock, TeachBlockPage} from "./types";
const base = process.env.PUBLIC_URL || ``;

export const branch0Ivan = {
    start: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'IvanAnalyzes',
        cardClick: 'patientIvanCard',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'patientIvanCardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    patientIvanCardFirst: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "IvanAnalyzes",
            closeClick: "tuktukIvan",
            pages: [`${base}/images/patient_ivan_enter_card1.png`, `${base}/images/patient_ivan_enter_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientIvanCard: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "IvanAnalyzesAfter",
            closeClick: "ivanFirstQuestion",
            pages: [`${base}/images/patient_ivan_enter_card1.png`, `${base}/images/patient_ivan_enter_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    tuktukIvan: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'enterIvan', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enterIvan: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Здравствуйте, доктор. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите.", type: "nextStep", gotoStep:'ivanFirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFirstQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Я вообще в Северокрайске совсем недавно. Я от ПНГ лечусь уже год, но вот пришлось переехать полгода назад. Пришел прикрепляться к Вам в поликлинику.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'ivanQuestions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'IvanAnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEnterAfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanQuestions: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Трансфузии", type: "nextStep", gotoStep:'ivanQuestion1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'ivanQuestion2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Усталость при нагрузках", type: "nextStep", gotoStep:'ivanQuestion3', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'ivanQuestion4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'ivanQuestion5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'ivanQuestion6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'ivanQuestion7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanFirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanQuestion1: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Была одна за весь год, через пару недель после начала терапии.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanQuestion2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanQuestion3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Я с тех пор как начал терапию - получше. Вот даже переезд одолел! Правда, было очень непросто... Вообще день выглядит так: начну что-то делать, потом сразу сажусь отдыхать. И так по кругу.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanQuestion4: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Меня как учили? Зарядка каждый день. Но мне физически сложно, поэтому нагрузки мало.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanQuestion5: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanQuestion6: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanQuestion7: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Не было ни разу с тех пор, как лечиться начал.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    IvanAnalyzes: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientIvanCardFirst",
            nextClick: "tuktukIvan",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_enter_1_table.jpg`],
                [`${base}/images/analiz_ivan_enter_2_table.jpg`],
                [`${base}/images/analiz_ivan_enter_3_table.jpg`],
                [`${base}/images/analiz_ivan_enter_4_table.jpg`],
                [`${base}/images/analiz_ivan_enter_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    IvanAnalyzesAfter: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientIvanCard",
            nextClick: "ivanFirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_enter_1_table.jpg`],
                [`${base}/images/analiz_ivan_enter_2_table.jpg`],
                [`${base}/images/analiz_ivan_enter_3_table.jpg`],
                [`${base}/images/analiz_ivan_enter_4_table.jpg`],
                [`${base}/images/analiz_ivan_enter_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterAfterQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'ivanEnterOsmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEnterMind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterOsmotr: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'ivanEnterOsmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'ivanEnterOsmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'ivanEnterOsmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEnterAfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterOsmotr1: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС — 101 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEnterOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterOsmotr2: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Наблюдается бледность кожных покровов',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEnterOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterOsmotr3: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEnterOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterMind: {
        patient: 'Ivan',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Согласно результатам проведенных исследований, у пациента наблюдаются признаки внесосудистого гемолиза, о чем могут свидетельствовать:<ul><li>Персистирующая анемия</li><li>Положительная прямая проба Кумбса</li><li>Ретикулоцитоз >120 тыс/мкл</li><li>Гипербилирубинемия за счет непрямой фракции >1,5хВГН</li></ul>Клинические и лабораторные данные могут указывать на наличие у пациента внесосудистого гемолиза. Учитывая данный фактор, какую терапию рекомендуется назначить пациенту?</i>',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanEnterMindLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEnterAfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterMindLink: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br> <a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br> (дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEnterMind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterAfterFisk: {
        patient: 'Ivan',
        branch: 0,
        name: '❗ ВНИМАНИЕ',
        text: '📘 Доступен <strong>новый материал</strong>! Изучите его как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br><br>👀 Нажмите <strong>"Читать справочник"</strong> – там свежий материал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'ivanEnterDocs', value: false, redColor: true, answered: false},
            {text: "Принять решение", type: "nextStep", gotoStep:'ivanEnterChoise', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterDocs: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "ivanGematogenEnter",
            pages: [
                {image: `${base}/images/ivan_teach_enter_1.png`, scroll: true},
                {image: `${base}/images/ivan_teach_enter_2.png`, scroll: true},
                {image: `${base}/images/ivan_teach_enter_3.png`, scroll: true},
            ]
        }
    },
    ivanGematogenEnter: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEnterAfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterChoise: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Продолжить терапию экулизумабом", type: "nextStep", gotoStep:'ivanEnterLine1', value: false, redColor: false, answered: false},
            {text: "Экулизумаб\n(сокращение интервала введения)", type: "nextStep", gotoStep:'ivanEnterLine2', value: false, redColor: false, answered: false},
            {text: "Иптакопан", type: "nextStep", gotoStep:'ivanE1ChoiseLine3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine1: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Оставим ту же терапию, будем наблюдать.<br><br>Поддерживающая терапия: 900 мг каждые 14 дней.<br><br>Жду вас на прием с результатами общего и биохимического анализа крови.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanEnterLine1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEnterLine1Next', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine1Link: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Элизария® </strong><br>ЛП-№(000140)-(РГ-RU) от 18.02.2021',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEnterLine1', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine1Next: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Хорошо, доктор. Понял, сделаю.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'ivanEnterLine1Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine1Finish: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'ivanE1Cabinet', value: false, redColor: false, answered: false, patient: "Ivan"},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Предлагаю немного скорректировать терапию и уменьшить интервал между приемами экулизумаба.<br><br>900 мг препарата внутривенно капельно каждые 12 дней.<br><br>Жду Вас через 6 месяцев на повторный прием.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanEnterLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEnterLine2Next', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine2Link: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Элизария® </strong><br>ЛП-№(000140)-(РГ-RU) от 18.02.2021',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEnterLine2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine2Next: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Хорошо, когда мне прийти к Вам в следующий раз? ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanEnterLine2Next2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine2Next2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Я записал Вас на прием через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanEnterLine2Next3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine2Next3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Хорошо, доктор. Тогда до следующего визита!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'ivanEnterLine2Finish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEnterLine2Finish: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'ivanEP2Cabinet', value: false, redColor: false, answered: false, patient: "Ivan"},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    ivanE1Cabinet: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'ivanE1Analyzes',
        cardClick: 'ivanE1CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'ivanE1CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1CardFirst: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanE1Analyzes",
            closeClick: "ivanE1tuktuk",
            pages: [`${base}/images/patient_ivan_e1_card1.png`, `${base}/images/patient_ivan_e1_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Card: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanE1AnalyzesAfter",
            closeClick: "ivanE1FirstQuestion",
            pages: [`${base}/images/patient_ivan_e1_card1.png`, `${base}/images/patient_ivan_e1_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1tuktuk: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'ivanE1enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1enter: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Здравствуйте, доктор.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите.", type: "nextStep", gotoStep:'ivanE1FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1FirstQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Знаете, доктор. Что-то мне за полгода, что мы с Вами не виделись - совсем не стало лучше. Все время хочется полежать и отдохнуть, даже когда.. я уже и так лежу и отдыхаю. Что же мне делать? ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'ivanE1Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'ivanE1AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Questions: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Трансфузии", type: "nextStep", gotoStep:'ivanE1Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'ivanE1Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Усталость при нагрузках", type: "nextStep", gotoStep:'ivanE1Question3', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'ivanE1Question4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'ivanE1Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'ivanE1Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'ivanE1Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Другие жалобы", type: "nextStep", gotoStep:'ivanE1Question8', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Question1: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Да, были, несколько раз мне делали трансфузии, когда гемоглобин сильно падал. После трансфузий чувствовал себя немного лучше, но ненадолго.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Question2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Question3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Как-то будто бы усилилась. Еще и голова стала кружиться вдобавок.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Question4: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'С зарядкой не выходит сейчас. Сил не хватает, а если уж возьмусь - то одышка очень сильная.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Question5: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Question6: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Question7: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Было пару раз.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Question8: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Да, доктор. Может быть, это возраст, но у меня пояивлись проблемы с потенцией.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanE1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Analyzes: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanE1CardFirst",
            nextClick: "ivanE1tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_e1_1_table.jpg`],
                [`${base}/images/analiz_ivan_e1_2_table.jpg`],
                [`${base}/images/analiz_ivan_e1_3_table.jpg`],
                [`${base}/images/analiz_ivan_e1_4_table.jpg`],
                [`${base}/images/analiz_ivan_e1_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1AnalyzesAfter: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanE1Card",
            nextClick: "ivanE1FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_e1_1_table.jpg`],
                [`${base}/images/analiz_ivan_e1_2_table.jpg`],
                [`${base}/images/analiz_ivan_e1_3_table.jpg`],
                [`${base}/images/analiz_ivan_e1_4_table.jpg`],
                [`${base}/images/analiz_ivan_e1_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1AfterQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'ivanE1Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Osmotr: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'ivanE1Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'ivanE1Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'ivanE1Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Osmotr1: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 103 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Osmotr2: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Степень бледности повысилась, наблюдается иктеричность склер',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Osmotr3: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Mind: {
        patient: 'Ivan',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Пациент продолжает получать терапию экулизумабом, но уровень гемоглобина все еще соответствует субоптимальному ответу на терапию. Лабораторные исследования выявили наличие признаков внесосудистого гемолиза - персистирующая анемия, положительная прямая проба Кумбса, ретикулоцитоз и гипербилирубинемия. Необходимо принять решение о дальнейшей стратегии терапии..</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanE1MindLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1AfterFisk', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1MindLink: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1AfterFisk: {
        patient: 'Ivan',
        branch: 0,
        name: '❗ ВНИМАНИЕ',
        text: '📘 Доступен новый материал! Изучите его как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong> – там свежий материал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'ivanE1Docs', value: false, redColor: true, answered: false},
            {text: "Принять решение", type: "nextStep", gotoStep:'ivanE1Choise', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Docs: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "ivanGematogenE1",
            pages: [
                {image: `${base}/images/ivan_teach_e1_1.png`, scroll: true},
                {image: `${base}/images/ivan_teach_e1_2.png`, scroll: true},
                {image: `${base}/images/ivan_teach_e1_3.png`, scroll: true},
                {image: `${base}/images/ivan_teach_e1_4.png`, scroll: true},
                {image: `${base}/images/ivan_teach_e1_5.png`, scroll: true},
            ]
        }
    },
    ivanGematogenE1: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1AfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Choise: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Экулизумаб\n(сокращение интервала введения)", type: "nextStep", gotoStep:'ivanEnterLine2', value: false, redColor: false, answered: false},
            {text: "Равулизумаб", type: "nextStep", gotoStep:'ivanE1ChoiseLine2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'},
            {text: "Иптакопан", type: "nextStep", gotoStep:'ivanE1ChoiseLine3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Назначаю Вам равулизумаб.<br><br>Через 2 недели после последней инфузии экулизумаба мы введем первую нагрузочную дозу. Затем поддерживающая доза будет вводиться каждые 8 недель.<br><br>Посмотрим на динамику, жду Вас через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanE1ChoiseLine2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1ChoiseLine2_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine2Link: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис®</strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1ChoiseLine2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine2_2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'А как его будут вводить?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1ChoiseLine2_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine2_3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Принимается так же, как экулизумаб, но значительно реже. Надя составит для Вас график.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanE1ChoiseLine2_3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1ChoiseLine2_4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine2_3Link: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Элизария®</strong><br>ЛП-№(000140)-(РГ-RU) от 18.02.2021<br><br><strong>ОХЛП: Общая характеристика лекарственного препарата Ултомирис®</strong><br>ЛП-№(001862)-(РГ-RU) от 28.02.2023',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1ChoiseLine2_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine2_4: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Спасибо, доктор! Буду надеяться, смена терапии принесет свои плоды. Мне хочется побольше времени активно с внуками проводить.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet2.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'ivanE1ChoiseLine2Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine2Finish: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'ivanR2Cabinet', value: false, redColor: false, answered: false, patient: "Ivan"},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Предлагаю перейти на иптакопан. Это препарат в капсулах по 200 мг, принимать нужно 2 раза в день ежедневно. Но прежде чем мы перейдем к новой терапии - Вам обязательно нужно сделать вакцинацию. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanE1ChoiseLine3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1Test', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine3Link: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1ChoiseLine3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Test: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: true,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: `${base}/images/aksinya_questions1.png`,
        stepSound: '',
        rating: 0,
        buttons: [],
        question: {
            title: "Выберите из списка вакцин две обязательных и одну рекомендованную ",
            result: "<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024",
            nextStep: "ivanE1ChoiseLine3_2",
            nextStepCorrect: "ivanE1Correct",
            answers: [
                {name: "Грипп", correct: false},
                {name: "Менингококк", correct: true},
                {name: "Полиомиелит", correct: false},
                {name: "Пневмококк", correct: true},
                {name: "Гепатит B", correct: false},
                {name: "ВИЧ", correct: false},
                {name: "Гемофильная палочка", correct: true},
            ]
        },
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1Correct: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐️<br><br>📈 Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1ChoiseLine3_2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine3_2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Все ясно! Сначала привики, потом препарат. А как его хранить дома? В холодильнике? А после еды пить? Или до? ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'ivanE1ChoiseLine3Docs', value: false, redColor: true, answered: false},
            {text: "Ответить", type: "nextStep", gotoStep:'ivanE1ChoiseLine3_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine3Docs: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "ivanGematogenLine3E1",
            pages: [
                {image: `${base}/images/ivan_teach_e1_11.png`, scroll: true},
                {image: `${base}/images/ivan_teach_e1_12.png`, scroll: true},
                {image: `${base}/images/ivan_teach_e1_13.png`, scroll: true},
                {image: `${base}/images/ivan_teach_e1_14.png`, scroll: true},
            ]
        }
    },
    ivanGematogenLine3E1: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1ChoiseLine3_3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine3_3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Хранить при температуре не выше 30°С.<br><br>Принимать по 1 капсуле 2 раза в сутки. Можно с едой или без - как удобнее. Капсулы глотать целиком, не вскрывать и не разжёвывать, запивать водой.<br><br>При пропуске приема одной или нескольких доз следует принять одну дозу препарата как можно скорее (даже незадолго до приема следующей запланированной дозы и затем возобновить обычную схему лечения).',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet2.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanE1ChoiseLine3_3Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanE1ChoiseLine3_4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine3_3Link: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet2.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanE1ChoiseLine3_3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine3_4: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Понятно! Тогда запишите меня на следующий прием, приду подготовленным!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet2.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'ivanE1ChoiseLine3Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanE1ChoiseLine3Finish: {
        patient: 'Ivan',
        branch: 0,
        name: 'Надя',
        text: 'Записала!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Спасибо, Надя.", type: "closeTelegramBot", gotoStep:'ivanI1Cabinet', value: false, redColor: false, answered: false, patient: "Ivan"},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    ivanEP2Cabinet: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'ivanEP2Analyzes',
        cardClick: 'ivanEP2CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'ivanEP2CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2CardFirst: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanEP2Analyzes",
            closeClick: "ivanEP2tuktuk",
            pages: [`${base}/images/patient_ivan_ep2_ep3_card1.png`, `${base}/images/patient_ivan_ep2_ep3_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Card: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanEP2AnalyzesAfter",
            closeClick: "ivanEP2FirstQuestion",
            pages: [`${base}/images/patient_ivan_ep2_ep3_card1.png`, `${base}/images/patient_ivan_ep2_ep3_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2tuktuk: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'ivanEP2enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2enter: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Здравствуйте, доктор.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите.", type: "nextStep", gotoStep:'ivanEP2FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2FirstQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Я так хотел с Вами встретиться, усталость не отпускает! Я строго придерживаюсь плану лечения, но кажется, что самочувствие не улучшается. Просыпаюсь — и уже нет сил, как после тяжёлой работы. Даже простые вещи даются с трудом: одеться, выйти на улицу, пройтись по снегу — всё становится испытанием.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'ivanEP2Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'ivanEP2AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Questions: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Трансфузии", type: "nextStep", gotoStep:'ivanEP2Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'ivanEP2Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Усталость при нагрузках", type: "nextStep", gotoStep:'ivanEP2Question3', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'ivanEP2Question4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'ivanEP2Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'ivanEP2Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'ivanEP2Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP2FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Question1: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Да, переливали, когда гемоглобин несколько раз упал ниже 70 г/л.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Question2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Question3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Совсем простые вещи делаю в течение дня в последнее время. Если перенапрягаюсь - то устаю так, что на следующий день приходится брать выходной. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Question4: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'По-прежнему, маловато. Знаете, как я зарядку сейчас делаю? Пока лежу утром - ступни туда-сюда сгибаю-разгибаю, руки тоже. Так получается, что я и лежу, и хоть что-то полезное делаю. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Question5: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Question6: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Question7: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Analyzes: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanEP2CardFirst",
            nextClick: "ivanEP2tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_ep2_1_table.jpg`],
                [`${base}/images/analiz_ivan_ep2_2_table.jpg`],
                [`${base}/images/analiz_ivan_ep2_3_table.jpg`],
                [`${base}/images/analiz_ivan_ep2_4_table.jpg`],
                [`${base}/images/analiz_ivan_ep2_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2AnalyzesAfter: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanEP2Card",
            nextClick: "ivanEP2FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_ep2_1_table.jpg`],
                [`${base}/images/analiz_ivan_ep2_2_table.jpg`],
                [`${base}/images/analiz_ivan_ep2_3_table.jpg`],
                [`${base}/images/analiz_ivan_ep2_4_table.jpg`],
                [`${base}/images/analiz_ivan_ep2_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2AfterQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'ivanEP2Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP2Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Osmotr: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'ivanEP2Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'ivanEP2Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'ivanEP2Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Osmotr1: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Тахикардия. ЧСС - 105 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Osmotr2: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Наблюдается бледность и иктеричность склер',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Osmotr3: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Все в норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Mind: {
        patient: 'Ivan',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Улучшений не зафиксировано. Кажется, пришло время для смены терапии.</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP2AfterFisk', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2AfterFisk: {
        patient: 'Ivan',
        branch: 0,
        name: '❗ ВНИМАНИЕ',
        text: '📘 Доступен новый материал! Изучите его как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong> – там свежий материал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'ivanEP2Docs', value: false, redColor: true, answered: false},
            {text: "Принять решение", type: "nextStep", gotoStep:'ivanEP2Choise', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Docs: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "ivanGematogenEP2",
            pages: [
                {image: `${base}/images/ivan_teach_ep2_1.png`, scroll: true},
                {image: `${base}/images/ivan_teach_ep2_2.png`, scroll: true},
                {image: `${base}/images/ivan_teach_ep2_3.png`, scroll: true},
                {image: `${base}/images/ivan_teach_ep2_4.png`, scroll: true},
                {image: `${base}/images/ivan_teach_ep2_5.png`, scroll: true},
            ]
        }
    },
    ivanGematogenEP2: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP2AfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2Choise: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Продолжить терапию экулизумабом", type: "nextStep", gotoStep:'ivanEP2ChoiseLine1', value: false, redColor: false, answered: false},
            {text: "Равулизумаб", type: "nextStep", gotoStep:'ivanE1ChoiseLine2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'},
            {text: "Иптакопан", type: "nextStep", gotoStep:'ivanE1ChoiseLine3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)'}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2ChoiseLine1: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Оставим ту же терапию, но будем наблюдать.<br><br>Жду Вас на прием через 6 месяцев.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanEP2ChoiseLine1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP2ChoiseLine1_2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2ChoiseLine1Link: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Элизария®</strong><br>ЛП-№(000140)-(РГ-RU) от 18.02.2021',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP2ChoiseLine1', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2ChoiseLine1_2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Все-таки да? Хорошо, как скажете.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'ivanEP2ChoiseLine1Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP2ChoiseLine1Finish: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'ivanEP3Cabinet', value: false, redColor: false, answered: false, patient: "Ivan"},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    ivanEP3Cabinet: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'ivanEP3Analyzes',
        cardClick: 'ivanEP3CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'ivanEP3CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3CardFirst: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanEP3Analyzes",
            closeClick: "ivanEP3tuktuk",
            pages: [`${base}/images/patient_ivan_ep2_ep3_card1.png`, `${base}/images/patient_ivan_ep2_ep3_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Card: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanEP3AnalyzesAfter",
            closeClick: "ivanEP3FirstQuestion",
            pages: [`${base}/images/patient_ivan_ep2_ep3_card1.png`, `${base}/images/patient_ivan_ep2_ep3_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3tuktuk: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'ivanEP3enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3enter: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Здравствуйте, доктор. Хорошо, что у нас поликлиника всего в три этажа! Я бы выше не поднялся. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите.", type: "nextStep", gotoStep:'ivanEP3FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3FirstQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Доктор, я уже несколько месяцев чувствую сильную усталость, и она совсем не проходит, даже если стараюсь отдыхать. Я думал, что новый план лечения поможет, но с каждым месяцем состояние только ухудшается.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'ivanEP3Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'ivanEP3AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Questions: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Трансфузии", type: "nextStep", gotoStep:'ivanEP3Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'ivanEP3Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Усталость при нагрузках", type: "nextStep", gotoStep:'ivanEP3Question3', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'ivanEP3Question4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'ivanEP3Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'ivanEP3Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'ivanEP3Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP3FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Question1: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Да, приходилось переливать кровь, когда показатели были критическими. Честно говоря, устал от этих процедур — облегчение длится всего пару дней.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Question2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Question3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Честно говоря, за эти полгода как-то стал сильнее уставать ощутимо. Да вот даже, последнее: ко мне на выходных внук приехал - а я после рабочей недели пролежал всю субботу да воскресенье. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Question4: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'С зарядкой не складывается. Так что вся физическая нагрузка - это самые базовые движения человека.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Question5: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Question6: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Question7: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanEP3Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Analyzes: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanEP3CardFirst",
            nextClick: "ivanEP3tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_ep3_1_table.jpg`],
                [`${base}/images/analiz_ivan_ep3_2_table.jpg`],
                [`${base}/images/analiz_ivan_ep3_3_table.jpg`],
                [`${base}/images/analiz_ivan_ep3_4_table.jpg`],
                [`${base}/images/analiz_ivan_ep3_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3AnalyzesAfter: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanEP3Card",
            nextClick: "ivanEP3FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_ep3_1_table.jpg`],
                [`${base}/images/analiz_ivan_ep3_2_table.jpg`],
                [`${base}/images/analiz_ivan_ep3_3_table.jpg`],
                [`${base}/images/analiz_ivan_ep3_4_table.jpg`],
                [`${base}/images/analiz_ivan_ep3_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3AfterQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'ivanEP3Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP3Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Osmotr: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'ivanEP3Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'ivanEP3Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'ivanEP3Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP3AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Osmotr1: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'В пределах нормы',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Osmotr2: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Наблюдается бледность кожи и иктеричность склер',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Osmotr3: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Небольшое увеличение размеров селезенки',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP3Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Mind: {
        patient: 'Ivan',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Оптимальный ответ на терапию достигнут не был: уже больше года пациент получает экулизумаб, но гемоглобин находится на низком уровне. Лабораторные исследования подтверждают контроль внутрисосудистого гемолиза, но также наблюдаются признаки внесосудистого гемолиза. Может ли внесосудистый гемолиз являться причиной субоптимального ответа на патогенетическую терапию?</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanEP3MindLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP3AfterFisk', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3MindLink: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP3Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3AfterFisk: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Иван Аркадьевич, анализы показали признаки внесосудистого гемолиза. Нужно определить дальнейшую тактику лечения.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP3Items', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3Items: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Внесосудистый гемолиз? Но я строго следовал плану лечения, не пропустил ни одной инфузии. Как это могло произойти?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Причиной развития ВнСГ могла стать терапия ингибиторами С5", type: "nextStep", gotoStep:'ivanEP3ItemsCorrect', value: false, redColor: false, answered: false},
            {text: "В связи с возникшей резистентностью к терапии ингибиторами С5", type: "nextStep", gotoStep:'ivanEP3ItemsAfter', value: false, redColor: false, answered: false},
            {text: "Недостаточная концентрация ингибитора С5 в крови", type: "nextStep", gotoStep:'ivanEP3ItemsAfter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3ItemsCorrect: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐️<br><br>📈 Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP3ItemsAfter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3ItemsAfter: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Причиной развития ВнСГ может быть терапия ингибиторами С5 – экулизумабом или равулизумабом. Многие пациенты, у которых нет ответа на терапию данными препаратами, могут сталкиваться с данным состоянием.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanEP3ItemsAfterLink', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP3ItemsAfter2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3ItemsAfterLink: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Risitano, Antonio M et al. “Anti-complement Treatment for Paroxysmal Nocturnal Hemoglobinuria: Time for Proximal Complement Inhibition?</strong> A Position Paper From the SAAWP of the EBMT.” Frontiers in immunology vol. 10 1157. 14 Jun. 2019, doi:10.3389/fimmu.2019.01157',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP3ItemsAfter', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3ItemsAfter2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Развитие внесосудистого гемолиза связывают с механизмом действия ингибиторов C5, который предотвращает формирование мембраноатакуюшего комплекса на поверхности эритроцитов, но не препятствует опсонизации эритроцитов белками системы комплемента, в результате чего может происходить ВнСГ.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanEP3ItemsAfter2Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanEP3ItemsAfter3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3ItemsAfter2Link: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Risitano, Antonio M et al. “Anti-complement Treatment for Paroxysmal Nocturnal Hemoglobinuria: Time for Proximal Complement Inhibition?</strong> A Position Paper From the SAAWP of the EBMT.” Frontiers in immunology vol. 10 1157. 14 Jun. 2019, doi:10.3389/fimmu.2019.01157',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP3ItemsAfter2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3ItemsAfter3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Из-за разрушения эритроцитов в печени и селезенке Ваш гемоглобин постоянно падает, из-за этого вы чувствуете постоянную слабость. Если внесосудистый гемолиз сохраняется дольше 6 месяцев - мы обязательно должны сменить терапию. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanEP3ItemsAfter3Link', value: false, redColor: false, answered: false},
            {text: "Сменить терапию", type: "nextStep", gotoStep:'ivanEP3ItemsAfter4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3ItemsAfter3Link: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Risitano, Antonio M et al. “Anti-complement Treatment for Paroxysmal Nocturnal Hemoglobinuria: Time for Proximal Complement Inhibition?</strong> A Position Paper From the SAAWP of the EBMT.” Frontiers in immunology vol. 10 1157. 14 Jun. 2019, doi:10.3389/fimmu.2019.01157',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanEP3ItemsAfter3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanEP3ItemsAfter4: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Равулизумаб", type: "nextStep", gotoStep:'ivanE1ChoiseLine2', value: false, redColor: false, answered: false},
            {text: "Иптакопан", type: "nextStep", gotoStep:'ivanE1ChoiseLine3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    ivanR2Cabinet: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'ivanR2Analyzes',
        cardClick: 'ivanR2CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'ivanR2CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2CardFirst: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanR2Analyzes",
            closeClick: "ivanR2tuktuk",
            pages: [`${base}/images/patient_ivan_r2_card1.png`, `${base}/images/patient_ivan_r2_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Card: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanR2AnalyzesAfter",
            closeClick: "ivanR2FirstQuestion",
            pages: [`${base}/images/patient_ivan_r2_card1.png`, `${base}/images/patient_ivan_r2_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2tuktuk: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'ivanR2enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2enter: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Здравствуйте, доктор. Я как Вам  - как обычно - все по расписанию.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanEnter.jpg`,
        buttons: [
            {text: "Здравствуйте. Рад вас видеть, проходите.", type: "nextStep", gotoStep:'ivanR2FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2FirstQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Ну, не знаю, что рассказать сильно. Я уже в целом даже и привык к своему состоянию. Хотя... У меня гемоглобин падал до 60 г/л. Это уже совсем как-то нерадостно. Сейчас стабильнее.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'ivanR2Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'ivanR2AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanR2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Questions: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Трансфузии", type: "nextStep", gotoStep:'ivanR2Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'ivanR2Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Усталость при нагрузках", type: "nextStep", gotoStep:'ivanR2Question3', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'ivanR2Question4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'ivanR2Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'ivanR2Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'ivanR2Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanR2FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Question1: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Да, три раза за последние полгода делали переливания — дважды из-за низкого гемоглобина и один раз при прорывном гемолизе. Хочу верить, что медицина предложит способ уменьшить необходимость этих процедур.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Question2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Question3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Я тут отпуск взял. Подумал - вдруг поможет прямо вот вообще на работу не ходить, может, полегче станет. А в итоге чем-то заболел и вот только два дня как на улицу выхожу.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Question4: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Без изменений, доктор. К вам пришел - вот моя физическая нагрузка на день.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Question5: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Question6: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Question7: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Один раз было, да. Хорошо, что Вы спросили, я и забыл сам.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanR2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Analyzes: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanR2CardFirst",
            nextClick: "ivanR2tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_r2_1_table.jpg`],
                [`${base}/images/analiz_ivan_r2_2_table.jpg`],
                [`${base}/images/analiz_ivan_r2_3_table.jpg`],
                [`${base}/images/analiz_ivan_r2_4_table.jpg`],
                [`${base}/images/analiz_ivan_r2_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2AnalyzesAfter: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanR2Card",
            nextClick: "ivanR2FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_r2_1_table.jpg`],
                [`${base}/images/analiz_ivan_r2_2_table.jpg`],
                [`${base}/images/analiz_ivan_r2_3_table.jpg`],
                [`${base}/images/analiz_ivan_r2_4_table.jpg`],
                [`${base}/images/analiz_ivan_r2_5_table.jpg`]
            ],
            analyzesHeights: [
                [467],
                [434],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2AfterQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'ivanR2Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanR2Mind', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Osmotr: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'ivanR2Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'ivanR2Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'ivanR2Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanR2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Osmotr1: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'В пределах нормы',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanR2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Osmotr2: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Наблюдается заметная бледность кожи и иктеричность склер',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanR2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Osmotr3: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'В норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanR2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2Mind: {
        patient: 'Ivan',
        branch: 0,
        name: '💭 Размышления',
        text: '<i>Все симптомы усугубились. Уровень гемоглобина стабильно падает, 93 г/л соответствует субоптимальному ответу. Фиксировалось многократное падение гемоглобина на протяжении 6 месяцев. Необходимо рассмотреть новые опции терапии.</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'ivanR2MindLink', value: false, redColor: false, answered: false},
            {text: "Перейти на иптакопан", type: "nextStep", gotoStep:'ivanE1ChoiseLine3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanR2MindLink: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanR2Mind', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    ivanI1Cabinet: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'ivanI1Analyzes',
        cardClick: 'ivanI1CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'ivanI1CardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1CardFirst: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanI1Analyzes",
            closeClick: "ivanI1tuktuk",
            pages: [`${base}/images/patient_ivan_i1_final_card1.png`, `${base}/images/patient_ivan_i1_final_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Card: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanI1AnalyzesAfter",
            closeClick: "ivanI1FirstQuestion",
            pages: [`${base}/images/patient_ivan_i1_final_card1.png`, `${base}/images/patient_ivan_i1_final_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1tuktuk: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Уверенный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'ivanI1enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1enter: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Здравствуйте, доктор. Я сейчас по лестнице к Вам прямо почти взлетел!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите, рассказывайте.", type: "nextStep", gotoStep:'ivanI1enter2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1enter2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Доктор, сам себе не верю, что сейчас скажу это, но я стал чувствовать себя гораздо лучше! Боюсь сглазить!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanI1enter3', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1enter3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Надя (трижды стучит по дереву)',
        text: 'Тьфу-тьфу-тьфу!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanI1FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1FirstQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Это замечательные новости! Давайте проведем опрос и осмотрим вас. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'ivanI1Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'ivanI1AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanI1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Questions: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Трансфузии", type: "nextStep", gotoStep:'ivanI1Question1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'ivanI1Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Усталость при нагрузках", type: "nextStep", gotoStep:'ivanI1Question3', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'ivanI1Question4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'ivanI1Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'ivanI1Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'ivanI1Question7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanI1FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Question1: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanI1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Question2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanI1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Question3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Все хорошо! Я и на работу хожу, и на прогулку успеваю, и с внуком на выходных поиграть. Устаю только под конец дня.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanI1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Question4: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Стал бегать по утрам пару раз в неделю. Маленький кружочек вокруг озера около дома, но все-таки!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanI1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Question5: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanI1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Question6: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Нет, таких проблем нет.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanI1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Question7: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanI1Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Analyzes: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanI1CardFirst",
            nextClick: "ivanI1tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_i1_1_table.jpg`],
                [`${base}/images/analiz_ivan_i1_2_table.jpg`],
                [`${base}/images/analiz_ivan_i1_3_table.jpg`],
                [`${base}/images/analiz_ivan_i1_4_table.jpg`],
                [`${base}/images/analiz_ivan_i1_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1AnalyzesAfter: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanI1Card",
            nextClick: "ivanI1FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_i1_1_table.jpg`],
                [`${base}/images/analiz_ivan_i1_2_table.jpg`],
                [`${base}/images/analiz_ivan_i1_3_table.jpg`],
                [`${base}/images/analiz_ivan_i1_4_table.jpg`],
                [`${base}/images/analiz_ivan_i1_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1AfterQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'ivanI1Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanI1Next', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Osmotr: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'ivanI1Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'ivanI1Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'ivanI1Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanI1AfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Osmotr1: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'В пределах нормы. ЧСС - 80 уд/сек',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanI1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Osmotr2: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Нормальные кожные покровы, желтизна исчезла',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanI1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Osmotr3: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'В норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanI1Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Next: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Вот и замечательно. Жду Вас на прием через месяц. Проверим динамику.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanI1Next2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Next2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Понял, записал! Буду.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Записать пациента", type: "nextStep", gotoStep:'ivanI1Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanI1Finish: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-55%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'ivanFinalCabinet', value: false, redColor: false, answered: false, patient: "Ivan"},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    ivanFinalCabinet: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Новое письмо из лаборатории!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'ivanFinalAnalyzes',
        cardClick: 'ivanFinalCardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [
            {text: "Открыть письмо", type: "nextStep", gotoStep: 'ivanFinalCardFirst', value: false, redColor: false, answered: false, clickSound: true}
        ],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalCardFirst: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanFinalAnalyzes",
            closeClick: "ivanFinaltuktuk",
            pages: [`${base}/images/patient_ivan_i1_final_card1.png`, `${base}/images/patient_ivan_i1_final_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalCard: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "ivanFinalAnalyzesAfter",
            closeClick: "ivanFinalFirstQuestion",
            pages: [`${base}/images/patient_ivan_i1_final_card1.png`, `${base}/images/patient_ivan_i1_final_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinaltuktuk: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Уверенный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'ivanFinalenter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalenter: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, ну как самочувствие?", type: "nextStep", gotoStep:'ivanFinalenter2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalenter2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Ну прямо не нарадуюсь! Внук говорит - я помолодел.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanFinalFirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalFirstQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Это замечательные новости! Давайте проведем опрос и осмотрим вас.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить пациента", type: "nextStep", gotoStep:'ivanFinalQuestions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'ivanFinalAnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanFinalAfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalQuestions: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Трансфузии", type: "nextStep", gotoStep:'ivanFinalQuestion1', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Боль в груди", type: "nextStep", gotoStep:'ivanFinalQuestion2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Усталость при нагрузках", type: "nextStep", gotoStep:'ivanFinalQuestion3', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'ivanFinalQuestion4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Головная боль / Зрение", type: "nextStep", gotoStep:'ivanFinalQuestion5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Боль в нижних конечностях", type: "nextStep", gotoStep:'ivanFinalQuestion6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'ivanFinalQuestion7', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'ivanFinalFirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalQuestion1: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanFinalQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalQuestion2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Все в порядке, нет таких проблем.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanFinalQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalQuestion3: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Знаете, доктор. Я прямо нормально себя чувствую. Знаете, как я это понял? Я наконец перестал все время думать о том, что я устал и нужно скорее сделать перерыв от дел. Сейчас занимаюсь спокойно чем-нибудь без навязчивых фоновых мыслей о самочувствии.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanFinalQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalQuestion4: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'На прошлой неделе сделал два круга вокруг озера! Стабильно бегаю 2 раза в неделю.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanFinalQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalQuestion5: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Все в порядке, нет таких проблем.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanFinalQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalQuestion6: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Все в порядке, нет таких проблем.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanFinalQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalQuestion7: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Не было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'ivanFinalQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalAnalyzes: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/IvanCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanFinalCardFirst",
            nextClick: "ivanFinaltuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_final_1_table.jpg`],
                [`${base}/images/analiz_ivan_final_2_table.jpg`],
                [`${base}/images/analiz_ivan_final_3_table.jpg`],
                [`${base}/images/analiz_ivan_final_4_table.jpg`],
                [`${base}/images/analiz_ivan_final_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalAnalyzesAfter: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "ivanFinalCard",
            nextClick: "ivanFinalFirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_ivan_final_1_table.jpg`],
                [`${base}/images/analiz_ivan_final_2_table.jpg`],
                [`${base}/images/analiz_ivan_final_3_table.jpg`],
                [`${base}/images/analiz_ivan_final_4_table.jpg`],
                [`${base}/images/analiz_ivan_final_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [361],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalAfterQuestion: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'ivanFinalOsmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanFinalNext', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalOsmotr: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'ivanFinalOsmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'ivanFinalOsmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'ivanFinalOsmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'ivanFinalAfterQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalOsmotr1: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'В пределах нормы. ЧСС - 85 уд/сек',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanFinalOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalOsmotr2: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'В норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanFinalOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalOsmotr3: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: 'Проблем при пальпации не выявлено',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'ivanFinalOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalNext: {
        patient: 'Ivan',
        branch: 0,
        name: 'Вы',
        text: 'Отлично. Я доволен нашими результатами. Соблюдаем режим приема препарата и регулярно наблюдайтесь, чтобы поддерживать достигнутый эффект.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'ivanFinalNext2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalNext2: {
        patient: 'Ivan',
        branch: 0,
        name: 'Иван',
        text: 'Понял! Буду точен как часы. Приду, как будет назначено.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/IvanCabinet.jpg`,
        buttons: [
            {text: "Закончить приём", type: "nextStep", gotoStep:'ivanFinalFinish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    ivanFinalFinish: {
        patient: 'Ivan',
        branch: 0,
        name: '',
        text: '<strong>Пациент стабилен! Отличная работа!<br>+ 30 баллов<br><br>🏆 Ваш рейтинг: ???⭐️<br><br>📈 Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'start', value: false, redColor: false, answered: false, patient: "Alex"},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },






}
